module.exports = __webpack_public_path__ + "img/blake.18249589.jpg";